import React from 'react'

const FormGroup: React.FC = ({ children }) => (
  <div className="pb-8">{children}</div>
)

export { FormGroup }
